import type { ReactNode } from "react";
import * as Dialog from "@radix-ui/react-dialog";

import { tw } from "@/utils";

interface ModalProps {
  children?: ReactNode;
  className?: string;
  show: boolean;
  title: ReactNode;
  description?: string;
  onClose: () => void;
}

export const Modal = ({
  children,
  className,
  show,
  title,
  description,
  onClose,
}: ModalProps) => (
  <Dialog.Root open={show} onOpenChange={onClose}>
    <Dialog.Portal>
      <Dialog.Overlay className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-neutral-800/80" />
      <Dialog.Content
        className={tw(
          "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] fixed left-1/2 top-1/2 z-50 grid max-h-[95vh] translate-x-[-50%] translate-y-[-50%] gap-y-8 overflow-y-auto border border-neutral-600 bg-white p-14 text-primary-950 shadow-md duration-200 sm:rounded-lg",
          className,
        )}
      >
        <div className="flex flex-col text-center sm:text-left">
          <Dialog.Title className="text-lg font-semibold leading-none tracking-tight">
            {title}
          </Dialog.Title>

          {description && (
            <Dialog.Description className="text-sm text-neutral-400">
              {description}
            </Dialog.Description>
          )}
        </div>
        {children}
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
